var React = require('react');

function Eqt (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"EQT logo"),React.createElement("g",{"key":1},React.createElement("path",{"d":"m 68.53991,31.6474 -12.7985,-12.7985 3.6769,-3.6769 12.7985,12.7985 z M 92.50001,11.6 l 5.2,0 0,19.5 -5.2,0 z M 0,0.8 l 5.2,0 0,30.3 -5.2,0 z m 10.8,25.1 18.5,0 0,5.2 -18.5,0 z m 0,-12.6 18.5,0 0,5.2 -18.5,0 z m 0,-12.5 18.5,0 0,5.2 -18.5,0 z m 69.60001,0 29.4,0 0,5.2 -29.4,0 z M 46,16 c 0,-5.9 4.80001,-10.8 10.80001,-10.8 6,0 10.7,4.9 10.7,10.8 0,0 0,0 0,0.1 l 5.2,0 c 0,0 0,0 0,-0.1 0,-8.8 -7.2,-16 -16,-16 C 47.9,0 40.7,7.2 40.7,16 c 0,8.8 7.1,16 15.90001,16 l 0,-5.2 C 50.70001,26.7 46,21.9 46,16 Z"}))]);
}

Eqt.defaultProps = {"version":"1.1","width":"1024","height":"311","viewBox":"-0.96 -0.96 111.72001 33.92"};

module.exports = Eqt;

Eqt.default = Eqt;
